import httpClient from "./httpClient";

const inscriptionService = {
  signUp(data) {
    return httpClient.post("/api/adv/sign-up", data);
  },
  confirmationByToken() {
    return httpClient.post("/api/adv/send-confirmation-Email-by-token");
  },
  confirmationByEmail() {
    return httpClient.post("/api/adv/account/email/confirm");
  },

  // follow API from page
  sendConfirmationEmail(data) {
    return httpClient.post("/send-account-confirmation-email", data);
  },
  sendPhoneConfirmationSMS(data) {
    return httpClient.post("/api/adv/profil/verify-phone-number", data);
  },
  sendLogin(phoneNumber, data) {
    return httpClient.post(`/api/adv/profil/send-auth/${phoneNumber}`, data);
  },
};

export default inscriptionService;
